import { useEffect } from 'react';
import { config } from '@/lib/config';

export function EnvTest() {
  // Environment variables are validated in config.ts
  // No need to log them here
  
  return null; // This is a non-visual component
}
